<template>

  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="12"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              Editing {{ suite.code }} - {{ suite.description }}
            </h1>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- Table Container Card -->
    <b-form @submit.prevent="submitForm">
      <validation-observer
        ref="suiteUpdateForm"
        #default="{invalid}"
      >
        <b-card
          header-tag="header"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                label="Suite Code"
                label-cols-md="3"
                label-for="code"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Suite Code"
                  vid="code"
                  rules=""
                >
                  <b-form-input
                    id="code"
                    v-model="code"
                    :state="(errors.length > 0) ? false : null"
                    name="code"
                    placeholder="Suite Code"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                label="Suite Name"
                label-cols-md="3"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Suite Name"
                  vid="name"
                  rules=""
                >
                  <b-form-input
                    id="name"
                    v-model="nameVal"
                    :state="(errors.length > 0) ? false : null"
                    name="name"
                    placeholder="Suite Name"
                    readonly
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              md="12"
              class="my-2"
            >
              <b-form-group
                label="Suite Image*"
                label-cols-md="3"
                label-for="image"
              >
                <div class="d-flex justify-content-start">
                  <div
                    class="image__block"
                  >
                    <b-img
                      class="mb-1 mb-sm-0 user__avatar img-preview-block"
                      :src="fileSrc ? fileSrc : defaultImage"
                    />
                  </div>

                  <div
                    class="upload__buttons my-auto mx-2"
                  >
                    <p>{{ imageNameOriginal }}</p>
                    <b-form-file
                      ref="fileInput"
                      v-model="image"
                      type="file"
                      accept="image/jpeg, image/jpg, image/png"
                      style="display: none"
                      @input="setImage"
                    />
                    <b-button
                      variant="primary"
                      class="mr-50"
                      @click="$refs.fileInput.$el.childNodes[0].click()"
                    >
                      Upload
                    </b-button>
                    <b-button
                      v-if="fileSrc"
                      variant="outline-primary"
                      class="mr-50"
                      @click="removeFileSrc()"
                    >
                      Remove
                    </b-button>
                  </div>
                </div>
                <small class="text-danger">{{ fileError }}</small>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="Related GIS Page"
                vid="gisPage"
                rules=""
              >
                <b-form-group
                  label="Related GIS Page"
                  label-for="h-team-gisPage"
                  label-cols-md="3"
                  description="Select a corresponding GIS page to connect this suite to its list of sections and their layouts."
                  :state="(errors.length > 0 || gisPageValidation) ? false : null"
                >
                  <v-select
                    id="h-team-gisPage"
                    v-model="gisPage"
                    label="name"
                    :options="gisPageOptions"
                    :reduce="page => page._id"
                    :clearable="false"
                    @input="gisPageValidation == true ? gisPageValidation = false : null"
                  >
                    <!-- <template #option="{ name, pageID }">
                      {{ pageID }}: {{ name }}
                    </template>
                    <template #selected-option="{ name, pageID }">
                      {{ pageID }}: {{ name }}
                    </template> -->
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="gisPageValidation"
                    class="text-danger"
                  >
                    {{ gisPageError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="12">
              <validation-provider
                #default="{ errors }"
                name="Location"
                vid="location"
                rules=""
              >
                <b-form-group
                  label="Location"
                  label-for="h-team-location"
                  label-cols-md="3"
                  description="Whether a location is selected, this suite can still be visible to agents depending on suite’s reservation/sales status."
                  :state="(errors.length > 0 || locationValidation) ? false : null"
                >
                  <v-select
                    id="h-team-location"
                    v-model="location"
                    label="name"
                    :options="locationOptions"
                    :reduce="title => title._id"
                    :clearable="false"
                    @input="locationValidation == true ? locationValidation = false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="locationValidation"
                    class="text-danger"
                  >
                    {{ locationError }}
                  </small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card>
        <b-nav class="wrap-border save-nav">
          <li class="nav-item">
            <span>You’re currently editing a Suite. Please save to avoid losing your data.</span>
          </li>
          <li
            class="nav-item ml-auto"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="flat-primary"
              @click="cancelRedirect"
            >
              Cancel
            </b-button>
          </li>
          <li
            class="nav-item mr-1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="success"
              :disabled="invalid"
            >
              <feather-icon
                icon="SaveIcon"
                class="mr-50"
              />
              <span class="align-middle">Save Changes</span>
            </b-button>
          </li>
        </b-nav>
      </validation-observer>
    </b-form>
    <!-- ./ create new category modal -->
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BNav, BImg, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { required } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BNav,
    BImg,
    BFormFile,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      defaultImage: require('@/assets/images/placeholder/placeholder_image.png'),
      image: null,
      imageName: '',
      imageNameOriginal: '',
      fileSrc: '',
      nameVal: '',
      code: '',
      gisPage: '',
      location: '',
      fileError: '',
      nameError: 'Valid Name is required',
      nameValidation: false,
      gisPageError: 'Valid Gis Page is required',
      gisPageValidation: false,
      locationError: 'Valid location is required',
      locationValidation: false,
      option: [{ title: 'Published', code: 'published' }, { title: 'Draft', code: 'draft' }],
      gisPageOptions: [],
      locationOptions: [],
      prevRoute: null,
      suite: {},
      // validation rules
      required,
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.prevRoute = from
    })
  },
  created() {
    this.$http.get('reservation/suites/respond-with/extra-options')
      .then(response => {
        this.locationOptions = response.data.locations ?? []
        this.gisPageOptions = response.data.gisPages.map(gisPage => ({ _id: gisPage._id, name: `${gisPage.pageID}: ${gisPage.name} ${gisPage.description ? `- ${gisPage.description}` : ''}` }))
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
    this.$http.get(`reservation/suites/${this.$route.params.id}`)
      .then(response => {
        this.suite = response.data
        this.fileSrc = response.data.image ?? null
        if (response.data.image) {
          this.imageName = response.data.image.split('/').pop()
          this.imageNameOriginal = this.imageName
        }
        this.nameVal = response.data.description ?? ''
        this.code = response.data.code || ''
        this.gisPage = response.data.gisPage ? response.data.gisPage._id : null
        this.location = response.data.location ? response.data.location._id : null

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const firstMeta = {
          to: `/products/suites/${this.$route.params.id}/show`,
          text: `${this.code} - ${this.nameVal}`,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', firstMeta)
        const newMeta = {
          active: true,
          text: `Editing ${this.code} - ${this.nameVal}`,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    setImage() {
      if (this.image) {
        if (this.image && this.image.size <= 5242880) {
          this.imageNameOriginal = this.image.name
          const reader = new FileReader()
          reader.readAsDataURL(this.image)
          reader.onload = () => {
            this.fileSrc = reader.result
          }
        } else {
          this.fileSrc = null
          this.imageNameOriginal = null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'File size not accepted more than 5MB',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      }
    },
    removeFileSrc() {
      this.fileSrc = null
      this.image = null
      this.imageNameOriginal = null
    },
    cancelRedirect() {
      if (window.history.length > 1) {
        this.$router.back()
        // this.$router.push({ name: this.prevRoute.name, query: this.prevRoute.query })
      } else {
        this.$router.push({ name: 'products-locations-index' })
      }
    },
    submitForm() {
      this.$refs.suiteUpdateForm.validate().then(async success => {
        if (!this.fileSrc) {
          this.fileError = 'The Image field is required'
        }
        if (success && this.fileSrc) {
          const formData = new FormData()
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', true)
          formData.append('gisPage', this.gisPage ?? '')
          formData.append('location', this.location ?? '')
          // formData.append('image', this.fileSrc)
          if (this.image) {
            const res = await this.uploadFileToAws(this.image)
            const { fileUrl, fileName, upload } = res
            if (upload && fileUrl) {
              formData.append('image', fileName)
              formData.append('imageStorage', 'aws')
            } else {
              formData.append('suiteImage', this.image)
            }
          } else {
            formData.append('imageStorage', this.suite.imageStorage ? this.suite.imageStorage : 'local')
            formData.append('image', this.imageName)
          }
          store.commit('appConfig/UPDATE_CONTINUOUS_LOADER', false)

          this.$http.patch(`reservation/suites/${this.$route.params.id}/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.$swal({
                title: 'Suite Updated',
                html: '',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/success.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary mt-1',
                },
                buttonsStyling: false,
              })
                .then(result => {
                  if (result.value) {
                    if (window.history.length > 1) {
                      this.$router.back()
                      // this.$router.push({ name: this.prevRoute.name, query: this.prevRoute.query })
                    } else {
                      this.$router.push({ name: 'products-locations-index' })
                    }
                  }
                })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'location') {
                    this.locationError = validationError.msg
                    this.locationValidation = true
                  } else if (validationError.param === 'gisPage') {
                    this.gisPageError = validationError.msg
                    this.gisPageValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style scoped>
  .step-class {
    color: #104D9D;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
  }
  .img-preview-block{
      box-sizing: border-box;
      width: 100px;
      height: 100px;
      border: 1px solid #D2DCEA;
      border-radius: 5px;
  }
</style>
